import { useTranslation } from 'react-i18next';
import { Button, Result } from 'ui';
import { useLogout } from 'common/services/hooks';

type P = {
  subTitle: string;
};

const FetchUserError = ({ subTitle }: P) => {
  const { t } = useTranslation();
  const onLogout = useLogout();

  return (
    <Result
      extra={
        <Button
          onClick={async () => {
            await onLogout();
          }}
          size="large"
          type="primary"
        >
          Logout
        </Button>
      }
      status="500"
      subTitle={t(subTitle)}
    />
  );
};

export default FetchUserError;
